import Raleway_Italic_ttf from "../../assets/fonts/Raleway/Raleway-Italic.ttf";
import Raleway_Italic_eot from "../../assets/fonts/Raleway/Raleway-Italic.eot";
import Raleway_Italic_woff from "../../assets/fonts/Raleway/Raleway-Italic.woff";
import Raleway_Italic_woff2 from "../../assets/fonts/Raleway/Raleway-Italic.woff2";
import Raleway_Italic_svg from "../../assets/fonts/Raleway/Raleway-Italic.svg";

import Raleway_Bold_ttf from "../../assets/fonts/Raleway/Raleway-Bold.ttf";
import Raleway_Bold_eot from "../../assets/fonts/Raleway/Raleway-Bold.eot";
import Raleway_Bold_woff from "../../assets/fonts/Raleway/Raleway-Bold.woff";
import Raleway_Bold_woff2 from "../../assets/fonts/Raleway/Raleway-Bold.woff2";
import Raleway_Bold_svg from "../../assets/fonts/Raleway/Raleway-Bold.svg";

import Raleway_Thin_ttf from "../../assets/fonts/Raleway/Raleway-Thin.ttf";
import Raleway_Thin_eot from "../../assets/fonts/Raleway/Raleway-Thin.eot";
import Raleway_Thin_woff from "../../assets/fonts/Raleway/Raleway-Thin.woff";
import Raleway_Thin_woff2 from "../../assets/fonts/Raleway/Raleway-Thin.woff2";
import Raleway_Thin_svg from "../../assets/fonts/Raleway/Raleway-Thin.svg";

import Raleway_LightItalic_ttf from "../../assets/fonts/Raleway/Raleway-LightItalic.ttf";
import Raleway_LightItalic_eot from "../../assets/fonts/Raleway/Raleway-LightItalic.eot";
import Raleway_LightItalic_woff from "../../assets/fonts/Raleway/Raleway-LightItalic.woff";
import Raleway_LightItalic_woff2 from "../../assets/fonts/Raleway/Raleway-LightItalic.woff2";
import Raleway_LightItalic_svg from "../../assets/fonts/Raleway/Raleway-LightItalic.svg";

import Raleway_BlackItalic_ttf from "../../assets/fonts/Raleway/Raleway-BlackItalic.ttf";
import Raleway_BlackItalic_eot from "../../assets/fonts/Raleway/Raleway-BlackItalic.eot";
import Raleway_BlackItalic_woff from "../../assets/fonts/Raleway/Raleway-BlackItalic.woff";
import Raleway_BlackItalic_woff2 from "../../assets/fonts/Raleway/Raleway-BlackItalic.woff2";
import Raleway_BlackItalic_svg from "../../assets/fonts/Raleway/Raleway-BlackItalic.svg";

import Raleway_Black_ttf from "../../assets/fonts/Raleway/Raleway-Black.ttf";
import Raleway_Black_eot from "../../assets/fonts/Raleway/Raleway-Black.eot";
import Raleway_Black_woff from "../../assets/fonts/Raleway/Raleway-Black.woff";
import Raleway_Black_woff2 from "../../assets/fonts/Raleway/Raleway-Black.woff2";
import Raleway_Black_svg from "../../assets/fonts/Raleway/Raleway-Black.svg";

import Raleway_Light_ttf from "../../assets/fonts/Raleway/Raleway-Light.ttf";
import Raleway_Light_eot from "../../assets/fonts/Raleway/Raleway-Light.eot";
import Raleway_Light_woff from "../../assets/fonts/Raleway/Raleway-Light.woff";
import Raleway_Light_woff2 from "../../assets/fonts/Raleway/Raleway-Light.woff2";
import Raleway_Light_svg from "../../assets/fonts/Raleway/Raleway-Light.svg";

import Raleway_SemiBoldItalic_ttf from "../../assets/fonts/Raleway/Raleway-SemiBoldItalic.ttf";
import Raleway_SemiBoldItalic_eot from "../../assets/fonts/Raleway/Raleway-SemiBoldItalic.eot";
import Raleway_SemiBoldItalic_woff from "../../assets/fonts/Raleway/Raleway-SemiBoldItalic.woff";
import Raleway_SemiBoldItalic_woff2 from "../../assets/fonts/Raleway/Raleway-SemiBoldItalic.woff2";
import Raleway_SemiBoldItalic_svg from "../../assets/fonts/Raleway/Raleway-SemiBoldItalic.svg";

import Raleway_ExtraLightItalic_ttf from "../../assets/fonts/Raleway/Raleway-ExtraLightItalic.ttf";
import Raleway_ExtraLightItalic_eot from "../../assets/fonts/Raleway/Raleway-ExtraLightItalic.eot";
import Raleway_ExtraLightItalic_woff from "../../assets/fonts/Raleway/Raleway-ExtraLightItalic.woff";
import Raleway_ExtraLightItalic_woff2 from "../../assets/fonts/Raleway/Raleway-ExtraLightItalic.woff2";
import Raleway_ExtraLightItalic_svg from "../../assets/fonts/Raleway/Raleway-ExtraLightItalic.svg";

import Raleway_Regular_ttf from "../../assets/fonts/Raleway/Raleway-Regular.ttf";
import Raleway_Regular_eot from "../../assets/fonts/Raleway/Raleway-Regular.eot";
import Raleway_Regular_woff from "../../assets/fonts/Raleway/Raleway-Regular.woff";
import Raleway_Regular_woff2 from "../../assets/fonts/Raleway/Raleway-Regular.woff2";
import Raleway_Regular_svg from "../../assets/fonts/Raleway/Raleway-Regular.svg";

import Raleway_ExtraBoldItalic_ttf from "../../assets/fonts/Raleway/Raleway-ExtraBoldItalic.ttf";
import Raleway_ExtraBoldItalic_eot from "../../assets/fonts/Raleway/Raleway-ExtraBoldItalic.eot";
import Raleway_ExtraBoldItalic_woff from "../../assets/fonts/Raleway/Raleway-ExtraBoldItalic.woff";
import Raleway_ExtraBoldItalic_woff2 from "../../assets/fonts/Raleway/Raleway-ExtraBoldItalic.woff2";
import Raleway_ExtraBoldItalic_svg from "../../assets/fonts/Raleway/Raleway-ExtraBoldItalic.svg";

import Raleway_ExtraBold_ttf from "../../assets/fonts/Raleway/Raleway-ExtraBold.ttf";
import Raleway_ExtraBold_eot from "../../assets/fonts/Raleway/Raleway-ExtraBold.eot";
import Raleway_ExtraBold_woff from "../../assets/fonts/Raleway/Raleway-ExtraBold.woff";
import Raleway_ExtraBold_woff2 from "../../assets/fonts/Raleway/Raleway-ExtraBold.woff2";
import Raleway_ExtraBold_svg from "../../assets/fonts/Raleway/Raleway-ExtraBold.svg";

import Raleway_SemiBold_ttf from "../../assets/fonts/Raleway/Raleway-SemiBold.ttf";
import Raleway_SemiBold_eot from "../../assets/fonts/Raleway/Raleway-SemiBold.eot";
import Raleway_SemiBold_woff from "../../assets/fonts/Raleway/Raleway-SemiBold.woff";
import Raleway_SemiBold_woff2 from "../../assets/fonts/Raleway/Raleway-SemiBold.woff2";
import Raleway_SemiBold_svg from "../../assets/fonts/Raleway/Raleway-SemiBold.svg";

import Raleway_Medium_ttf from "../../assets/fonts/Raleway/Raleway-Medium.ttf";
import Raleway_Medium_eot from "../../assets/fonts/Raleway/Raleway-Medium.eot";
import Raleway_Medium_woff from "../../assets/fonts/Raleway/Raleway-Medium.woff";
import Raleway_Medium_woff2 from "../../assets/fonts/Raleway/Raleway-Medium.woff2";
import Raleway_Medium_svg from "../../assets/fonts/Raleway/Raleway-Medium.svg";

import Raleway_ExtraLight_ttf from "../../assets/fonts/Raleway/Raleway-ExtraLight.ttf";
import Raleway_ExtraLight_eot from "../../assets/fonts/Raleway/Raleway-ExtraLight.eot";
import Raleway_ExtraLight_woff from "../../assets/fonts/Raleway/Raleway-ExtraLight.woff";
import Raleway_ExtraLight_woff2 from "../../assets/fonts/Raleway/Raleway-ExtraLight.woff2";
import Raleway_ExtraLight_svg from "../../assets/fonts/Raleway/Raleway-ExtraLight.svg";

import Raleway_ThinItalic_ttf from "../../assets/fonts/Raleway/Raleway-ThinItalic.ttf";
import Raleway_ThinItalic_eot from "../../assets/fonts/Raleway/Raleway-ThinItalic.eot";
import Raleway_ThinItalic_woff from "../../assets/fonts/Raleway/Raleway-ThinItalic.woff";
import Raleway_ThinItalic_woff2 from "../../assets/fonts/Raleway/Raleway-ThinItalic.woff2";
import Raleway_ThinItalic_svg from "../../assets/fonts/Raleway/Raleway-ThinItalic.svg";

import Raleway_MediumItalic_ttf from "../../assets/fonts/Raleway/Raleway-MediumItalic.ttf";
import Raleway_MediumItalic_eot from "../../assets/fonts/Raleway/Raleway-MediumItalic.eot";
import Raleway_MediumItalic_woff from "../../assets/fonts/Raleway/Raleway-MediumItalic.woff";
import Raleway_MediumItalic_woff2 from "../../assets/fonts/Raleway/Raleway-MediumItalic.woff2";
import Raleway_MediumItalic_svg from "../../assets/fonts/Raleway/Raleway-MediumItalic.svg";

import Raleway_BoldItalic_ttf from "../../assets/fonts/Raleway/Raleway-BoldItalic.ttf";
import Raleway_BoldItalic_eot from "../../assets/fonts/Raleway/Raleway-BoldItalic.eot";
import Raleway_BoldItalic_woff from "../../assets/fonts/Raleway/Raleway-BoldItalic.woff";
import Raleway_BoldItalic_woff2 from "../../assets/fonts/Raleway/Raleway-BoldItalic.woff2";
import Raleway_BoldItalic_svg from "../../assets/fonts/Raleway/Raleway-BoldItalic.svg";

export const FontRaleway = `
  
  @font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Italic_eot}');
    src: url('${Raleway_Italic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Italic_woff2}') format('woff2'),
         url('${Raleway_Italic_woff}') format('woff'),
         url('${Raleway_Italic_ttf}') format('truetype'),
         url('${Raleway_Italic_svg}#Raleway-Italic') format('svg');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}


@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Bold_eot}');
    src: url('${Raleway_Bold_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Bold_woff2}') format('woff2'),
         url('${Raleway_Bold_woff}') format('woff'),
         url('${Raleway_Bold_ttf}') format('truetype'),
         url('${Raleway_Bold_svg}#Raleway-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Thin_eot}');
    src: url('${Raleway_Thin_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Thin_woff2}') format('woff2'),
         url('${Raleway_Thin_woff}') format('woff'),
         url('${Raleway_Thin_ttf}') format('truetype'),
         url('${Raleway_Thin_svg}#Raleway-Thin') format('svg');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_LightItalic_eot}');
    src: url('${Raleway_LightItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_LightItalic_woff2}') format('woff2'),
         url('${Raleway_LightItalic_woff}') format('woff'),
         url('${Raleway_LightItalic_ttf}') format('truetype'),
         url('${Raleway_LightItalic_svg}#Raleway-LightItalic') format('svg');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_BlackItalic_eot}');
    src: url('${Raleway_BlackItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_BlackItalic_woff2}') format('woff2'),
         url('${Raleway_BlackItalic_woff}') format('woff'),
         url('${Raleway_BlackItalic_ttf}') format('truetype'),
         url('${Raleway_BlackItalic_svg}#Raleway-BlackItalic') format('svg');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Black_eot}');
    src: url('${Raleway_Black_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Black_woff2}') format('woff2'),
         url('${Raleway_Black_woff}') format('woff'),
         url('${Raleway_Black_ttf}') format('truetype'),
         url('${Raleway_Black_svg}#Raleway-Black') format('svg');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Light_eot}');
    src: url('${Raleway_Light_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Light_woff2}') format('woff2'),
         url('${Raleway_Light_woff}') format('woff'),
         url('${Raleway_Light_ttf}') format('truetype'),
         url('${Raleway_Light_svg}#Raleway-Light') format('svg');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_SemiBoldItalic_eot}');
    src: url('${Raleway_SemiBoldItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_SemiBoldItalic_woff2}') format('woff2'),
         url('${Raleway_SemiBoldItalic_woff}') format('woff'),
         url('${Raleway_SemiBoldItalic_ttf}') format('truetype'),
         url('${Raleway_SemiBoldItalic_svg}#Raleway-SemiBoldItalic') format('svg');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_ExtraLightItalic_eot}');
    src: url('${Raleway_ExtraLightItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_ExtraLightItalic_woff2}') format('woff2'),
         url('${Raleway_ExtraLightItalic_woff}') format('woff'),
         url('${Raleway_ExtraLightItalic_ttf}') format('truetype'),
         url('${Raleway_ExtraLightItalic_svg}#Raleway-ExtraLightItalic') format('svg');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Regular_eot}');
    src: url('${Raleway_Regular_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Regular_woff2}') format('woff2'),
         url('${Raleway_Regular_woff}') format('woff'),
         url('${Raleway_Regular_ttf}') format('truetype'),
         url('${Raleway_Regular_svg}#Raleway-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_ExtraBoldItalic_eot}');
    src: url('${Raleway_ExtraBoldItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_ExtraBoldItalic_woff2}') format('woff2'),
         url('${Raleway_ExtraBoldItalic_woff}') format('woff'),
         url('${Raleway_ExtraBoldItalic_ttf}') format('truetype'),
         url('${Raleway_ExtraBoldItalic_svg}#Raleway-ExtraBoldItalic') format('svg');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_ExtraBold_eot}');
    src: url('${Raleway_ExtraBold_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_ExtraBold_woff2}') format('woff2'),
         url('${Raleway_ExtraBold_woff}') format('woff'),
         url('${Raleway_ExtraBold_ttf}') format('truetype'),
         url('${Raleway_ExtraBold_svg}#Raleway-ExtraBold') format('svg');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_SemiBold_eot}');
    src: url('${Raleway_SemiBold_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_SemiBold_woff2}') format('woff2'),
         url('${Raleway_SemiBold_woff}') format('woff'),
         url('${Raleway_SemiBold_ttf}') format('truetype'),
         url('${Raleway_SemiBold_svg}#Raleway-SemiBold') format('svg');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_Medium_eot}');
    src: url('${Raleway_Medium_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_Medium_woff2}') format('woff2'),
         url('${Raleway_Medium_woff}') format('woff'),
         url('${Raleway_Medium_ttf}') format('truetype'),
         url('${Raleway_Medium_svg}#Raleway-Medium') format('svg');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_ExtraLight_eot}');
    src: url('${Raleway_ExtraLight_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_ExtraLight_woff2}') format('woff2'),
         url('${Raleway_ExtraLight_woff}') format('woff'),
         url('${Raleway_ExtraLight_ttf}') format('truetype'),
         url('${Raleway_ExtraLight_svg}#Raleway-ExtraLight') format('svg');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_ThinItalic_eot}');
    src: url('${Raleway_ThinItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_ThinItalic_woff2}') format('woff2'),
         url('${Raleway_ThinItalic_woff}') format('woff'),
         url('${Raleway_ThinItalic_ttf}') format('truetype'),
         url('${Raleway_ThinItalic_svg}#Raleway-ThinItalic') format('svg');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_MediumItalic_eot}');
    src: url('${Raleway_MediumItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_MediumItalic_woff2}') format('woff2'),
         url('${Raleway_MediumItalic_woff}') format('woff'),
         url('${Raleway_MediumItalic_ttf}') format('truetype'),
         url('${Raleway_MediumItalic_svg}#Raleway-MediumItalic') format('svg');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Raleway';
    src: url('${Raleway_BoldItalic_eot}');
    src: url('${Raleway_BoldItalic_eot}?#iefix') format('embedded-opentype'),
         url('${Raleway_BoldItalic_woff2}') format('woff2'),
         url('${Raleway_BoldItalic_woff}') format('woff'),
         url('${Raleway_BoldItalic_ttf}') format('truetype'),
         url('${Raleway_BoldItalic_svg}#Raleway-BoldItalic') format('svg');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}
`;